import styled from "styled-components";
import { FLEX } from "styles/flex";

export const Content = styled.div`
  margin-bottom: -12px;
  text-align: center;
  line-height: 1.4;
  color: ${({ theme }) => theme.COLORS.TEXT};
`;

export const ShareUploadContainer = styled.div`
  width: 100%;
  padding-bottom: 20px;
  .common-modal-input label + div {
    width: 100%;
  }
`;

export const ShareUploadedSuccess = styled.div`
  h3 {
    ${FLEX.FlexStartCenter};
    gap: 4px;
    margin-bottom: 10px;
    font-weight: 600;
  }
  color: ${({ theme }) => theme.COLORS.WHITE};
  padding: 30px 0;
`;

export const ShareUploading = styled.div`
  ${FLEX.FlexCenterCenter};
  padding: 0 0 30px;
`;
